export const PLATFORM_LIMITS = {
  instagram: 2200,
  threads: 500,
  linkedin: 3000,
  x: 280,
  twitter: 280,
  tiktok: 2200,
  facebook: 63206,
  telegram: 4096,
};

export function pickPlatformText(post, platform) {
  if (!post) return '';
  const platformVersions = post.platformVersions || {};
  const aliasKey = platform === 'x' ? 'twitter' : platform === 'twitter' ? 'x' : null;
  const direct = platformVersions[platform];
  if (direct && typeof direct === 'string' && direct.trim()) return direct;
  if (aliasKey) {
    const aliased = platformVersions[aliasKey];
    if (aliased && typeof aliased === 'string' && aliased.trim()) return aliased;
  }
  return [post.caption, post.body, post.hook].find(value => typeof value === 'string' && value.trim()) || '';
}

export function joinHashtags(hashtags) {
  if (!Array.isArray(hashtags) || !hashtags.length) return '';
  return hashtags
    .map(tag => (typeof tag === 'string' ? tag.trim() : ''))
    .filter(Boolean)
    .map(tag => (tag.startsWith('#') ? tag : `#${tag}`))
    .join(' ');
}

export function platformLabel(platform) {
  const labels = {
    instagram: 'Instagram',
    threads: 'Threads',
    linkedin: 'LinkedIn',
    x: 'X',
    twitter: 'X',
    tiktok: 'TikTok',
    facebook: 'Facebook',
    telegram: 'Telegram',
  };
  return labels[platform] || platform;
}

export function getCharacterLimit(platform) {
  return PLATFORM_LIMITS[platform] || 2200;
}
